import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "@/App.tsx";
import "@/index.css";

// Single mount point for the SPA. The application shell and routing live in
// App / routes.tsx.
const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found in index.html");
}
const root = rootEl;

function mount() {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

// Dev-only: install the mock broker API before mounting, so the auth context's
// mount-time refresh is already talking to the stub (BRK-S037). The gate is
// build-time constants — a build that sets neither MODE=development nor
// VITE_ENABLE_DEV_LOGIN=true folds this branch away and Rollup drops the dev
// module entirely, so nothing here ships to prod. (Kept inline, not via the
// config helper, so Vite can statically eliminate the branch.)
if (
  import.meta.env.MODE === "development" ||
  import.meta.env.VITE_ENABLE_DEV_LOGIN === "true"
) {
  void import("@/dev/devApiStub").then(({ installDevApiStub }) => {
    installDevApiStub();
    mount();
  });
} else {
  mount();
}
